import { createBrowserRouter } from "react-router-dom";
import { ROUTE_PATH } from "../constants/route";
import Login from "../pages/Login";
import PublicLayout from "../layout/PublicLayout";
import Dashboard from "../pages/Dashboard";
import Error404 from "../pages/404.jsx";
import SignUpForm from "../pages/SignUp/index.jsx";
import ForgetPassword from "../pages/ForgetPassword/index.jsx";
import CheckInbox from "../pages/ForgetPassword/CheckInbox.jsx";
import LinkExpired from "../pages/ForgetPassword/LinkExpired.jsx";
import ResendLink from "../pages/ForgetPassword/ResendLink.jsx";
import RegistrationRequest from "../pages/SignUp/RegistrationRequest.jsx";
import RegistrationExists from "../pages/SignUp/RegistrationExists.jsx";
import CreateProfile from "../pages/CreateProfile/index.jsx";
import Info from "../components/CommonComponents/Info/index.jsx";
import PrivateDashboard from "../pages/PrivateDashboard/index.jsx";
import PrivateLayout from "../layout/PrivateLayout/index.jsx";
import CustomerSupport from "../pages/CustomerSupport/index.jsx"
import Payments from "../pages/Payments/index.jsx";
import FavouritesSection from "../pages/Favourites/index.jsx";
import InvoiceSection from "../pages/InvoiceSection/index.jsx";
import OrderManagement from "../pages/OrderManagement/index.jsx";
import PaymentSuccess from "../pages/PaymentSuccess/index.jsx";
import InventorySetup from "../pages/InventorySetupNew";
import EditProfile from "../pages/EditProfile/index.jsx";
import ResetPassword from "../pages/ResetPassword/index.jsx";
//import ShopifyList from "../pages/ShopifyList/index.jsx";
import ShopifySetup from "../pages/ShopifySetup/index.jsx";
import AddEditProduct from "../pages/InventorySetupNew/AddEditProduct.jsx";
import ProductDetail from "../pages/InventorySetupNew/ProductDetail.jsx";

const routes = createBrowserRouter([
  {
    path: ROUTE_PATH.TERMS_AND_CONDITION,
    element: (
      <PublicLayout>
        <Info activeTab={0} />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.PRIVACY_POLICY,
    element: (
      <PublicLayout>
        <Info activeTab={1} />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.LOGIN,
    element: (
      <PublicLayout>
        <Login />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.DASHBOARD,
    element: (
      <PublicLayout>
        <Dashboard />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.SIGNUP,
    element: (
      <PublicLayout>
        <SignUpForm />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.FORGET_PASSWORD,
    element: (
      <PublicLayout>
        <ForgetPassword />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.FORGET_PASSWORD_CHECK_INBOX,
    element: (
      <PublicLayout>
        <CheckInbox />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.FORGET_PASSWORD_LINK_EXPIRED,
    element: (
      <PublicLayout>
        <LinkExpired />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.FORGET_PASSWORD_RESEND_LINK_FAILED,
    element: (
      <PublicLayout>
        <ResendLink />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.SIGNUP_REGISTRATION_REQUEST,
    element: (
      <PublicLayout>
        <RegistrationRequest />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.SIGNUP_REGISTRATIONS_EXISTS,
    element: (
      <PublicLayout>
        <RegistrationExists />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.CREATE_PROFILE,
    element: (
      <PublicLayout privateRoute={true}>
        <CreateProfile />
      </PublicLayout>
    ),
  },
  // {
  //   path: ROUTE_PATH.CREATE_SHOPIFY_LIST,
  //   element: (
  //     <PublicLayout privateRoute={true}>
  //       <ShopifyList />
  //     </PublicLayout>
  //   ),
  // },
  {
    path: ROUTE_PATH.PRIVATE_DASHBOARD,
    element: (
      <PrivateLayout privateRoute={true} title="Dashboard">
        <PrivateDashboard />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.ORDER_MANAGEMENT,
    element: (
      <PrivateLayout privateRoute={true} title="Dashboard">
        <OrderManagement />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.CUSTOMER_SUPPORT,
    element: (
      <PrivateLayout privateRoute={true} title="Customer Support">
        <CustomerSupport />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.CUSTOMER_SUPOORT_PUBLIC,
    element: (
      <PublicLayout >
        <CustomerSupport isPublic={true}/>
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.PAYMENTS,
    element: (
      <PrivateLayout privateRoute={true} title="Payments">
        <Payments />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.FAVOURITES,
    element: (
      <PrivateLayout privateRoute={true} title="Favorites">
        <FavouritesSection />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.INVOICES,
    element: (
      <PrivateLayout privateRoute={true} title="Invoices">
        <InvoiceSection />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.PAYMENT_SUCCESS,
    element: (
      <PublicLayout privateRoute={true} navigationPage="true">
        <PaymentSuccess />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.INVENTORY_SETUP,
    element: (
      <PrivateLayout privateRoute={true} title="Inventory Management">
        <InventorySetup />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.ADD_INVENTORY_PRODUCT_NEW,
    element: (
      <PrivateLayout privateRoute={true} title="Inventory Management">
        <AddEditProduct />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.EDIT_INVENTORY_PRODUCT,
    element: (
      <PrivateLayout privateRoute={true} title="Inventory Management">
        <AddEditProduct />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.DETAILS_INVENTORY_PRODUCT,
    element: (
      <PrivateLayout privateRoute={true} title="Inventory Management">
        <ProductDetail />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.SHOPIFY_SETUP,
    element: (
      <PrivateLayout privateRoute={true} title="Shopify Inventory">
        <ShopifySetup />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.EDIT_PROFILE,
    element: (
      <PrivateLayout privateRoute={true} title="Profile">
        <EditProfile />
      </PrivateLayout>
    ),
  },
  {
    path: ROUTE_PATH.RESET_PASSWORD,
    element: (
      <PublicLayout>
        <ResetPassword />
      </PublicLayout>
    ),
  },
  {
    path: "*",
    element: (
      <PublicLayout privateRoute={false}>
        <Error404 />
      </PublicLayout>
    ),
  },
]);

export default routes;
